import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

export default function UseTripsAvailable() {
  const { authFetch } = useAuth();

  const [tripsAvailable, setTripsAvailable] = useState([]);
  const [loadingTripsAvailable, setLoadingTripsAvailable] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const searchTripsAvailable = async () => {
      //if (!accessToken) return;

      try {
        setLoadingTripsAvailable(true);
        setError("");

        const response = await authFetch(
          `${API_URL}/api/viagens/disponibilizadas/`,
          {
            method: "GET",
            headers: {
              //Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data?.detail || "Erro ao buscar viagens.");
        }

        setTripsAvailable(data.resultados || []);
      } catch (err) {
        setError(err.message || "Erro inesperado.");
      } finally {
        setLoadingTripsAvailable(false);
      }
    };

    searchTripsAvailable();
  }, [authFetch]);

  return {
    tripsAvailable,
    loadingTripsAvailable,
  };
}
